module.exports = __webpack_public_path__ + "img/face_quiet.179506b7.jpg";